import { render, staticRenderFns } from "./StarshipCustomization.vue?vue&type=template&id=068247f0&lang=pug&"
import script from "./StarshipCustomization.vue?vue&type=script&lang=ts&"
export * from "./StarshipCustomization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports